import ProductWarrantyPolicy from "./product-warranty-policy.page";

export default ProductWarrantyPolicy;
